import { Check, Circle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { resolveSmbPhases } from "./smb-phases";

export function SmbStepper({ model, selected, onSelect }: {
  model: ReturnType<typeof resolveSmbPhases>; selected: number; onSelect: (index: number) => void;
}) {
  return <nav aria-label="Client phases" className="grid gap-2 sm:grid-cols-5">
    {model.phases.map((phase, index) => <Button key={phase.label} variant={selected === index ? "secondary" : "ghost"}
      disabled={index > model.current} onClick={() => onSelect(index)} aria-current={index === model.current ? "step" : undefined}
      className="h-auto min-w-0 justify-start gap-2 whitespace-normal px-3 py-3 text-left">
      {phase.status === "done" ? <Check className="h-4 w-4 shrink-0 text-primary" /> :
        phase.status === "in progress" ? <Loader2 className="h-4 w-4 shrink-0 animate-spin" /> : <Circle className="h-4 w-4 shrink-0" />}
      <span><span className="block text-xs font-medium">{index + 1}. {phase.label}</span><span className="block text-[10px] capitalize text-muted-foreground">{phase.status}</span></span>
    </Button>)}
  </nav>;
}
